var swiper = new Swiper('.myS', {
  autoplay: {
    delay: 2000,
  },

  loop: true,
});

var swiper = new Swiper('.mySlider', {
  // autoplay: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  loop: true,
});
